import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {AuthService, LookupService} from "../../../services";
import {BusinessUnitService} from "../../../modules/business-units/services";
import {environment} from "../../../../environments/environment";
import jwtDecode from "jwt-decode";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import { UtilService } from 'src/app/modules/shared/services';
import { IInviteTokenDto, IRegisterAppUser, IRegistrationInviteDto } from 'src/app/models/i-app-user';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-auth-register',
  templateUrl: './auth-register.component.html',
  styleUrls: ['./auth-register.component.scss']
})
export class AuthRegisterComponent implements OnInit {

  showPassword = false;
  currentYear = new Date().getFullYear();
  apiCallInProgress = false;
  isMinimalInviteRegistration: boolean = false;
  token: string = '';
  tokenDecoded?: IInviteTokenDto;
  stage: number = 1;

  userProfile?: string; // investor or issuer

  userForm = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, this.authService.passwordPatternValidator]),
    companyName: new FormControl('', [Validators.required]),
    jobTitle: new FormControl('', [Validators.required]),
    countryId: new FormControl('', [Validators.required]),
    subType: new FormControl('', [Validators.required]),
    profile: new FormControl('', [Validators.required]),
    timeZone: new FormControl(Intl.DateTimeFormat().resolvedOptions().timeZone, [])
  });

  constructor(private router: Router,
              private title: Title,
              private activatedRoute: ActivatedRoute,
              private toastrService: ToastrService,
              public authService: AuthService,
              public lookupService: LookupService,
              private util: UtilService,
              public businessUnits: BusinessUnitService) {

              }


  ngOnInit() {
    // set page title
    this.title.setTitle('Rondeivu | Register');

    this.userProfile = this.activatedRoute.snapshot.queryParamMap.get('profile') || undefined;
    
    if (!!this.userProfile) {
      // make sure it's all on lowercase
      this.userProfile = this.userProfile.toLowerCase();

      if (this.userProfile === 'investor' || this.userProfile === 'issuer') {
        this.userProfile = this.userProfile;
        this.userForm.get('profile')?.setValue(this.userProfile);
        this.stage = 2;
      }
      else {
        // if invalid profile, clear it out of the url route
        this.userProfile = undefined;
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: {},
          replaceUrl: true
        });
      }
    }

    let inviteToken = this.activatedRoute.snapshot.queryParamMap.get('invite') || undefined;
    if (!!inviteToken) {
      // decode the token 
      let decoded: IInviteTokenDto = jwtDecode<IInviteTokenDto>(inviteToken);
      this.token = inviteToken;
      this.tokenDecoded = decoded;

      // console.log("token decoded", decoded);
      if (!!decoded) {

        this.userForm.patchValue(decoded);
        this.userProfile = decoded.profile;
        this.stage = 2;
        // console.log("Invite registration for profile", this.userProfile);
        this.isMinimalInviteRegistration = true;

        // disable email field
        this.userForm.get("email")?.disable();

        // also make sure the form validations don't require fields not in the invite
        this.userForm.get("companyName")?.clearValidators();
        this.userForm.get("jobTitle")?.clearValidators();
        this.userForm.get("countryId")?.clearValidators();
        this.userForm.get("subType")?.clearValidators();

        // update validity after clearing validators
        this.userForm.get("companyName")?.updateValueAndValidity();
        this.userForm.get("jobTitle")?.updateValueAndValidity();
        this.userForm.get("countryId")?.updateValueAndValidity();
        this.userForm.get("subType")?.updateValueAndValidity();
      }
    }
  } 

  /**
   * Registers the user with Rondeivu API
   */
  public registerUser(): void {
    // console.log("register", this.userForm.getRawValue());
    // console.log(this.userForm.errors);

    if (!this.userProfile) {
      this.toastrService.error("User profile not selected!", "Registration Error");
      return;
    }

    this.userForm.get('profile')?.setValue(this.userProfile);

    if (this.userForm.invalid) {
      this.toastrService.error("Form Invalid!", "Registration Error");
      // var errors = Object.entries(this.userForm.controls).map(([key, control]) => key).filter(err => !!err);
      // console.log("Form Errors:", errors);
      return;
    }

    try {
      // determine registration type (minimal is just the invite registration, the other is a full business unit registration)
      if (this.isMinimalInviteRegistration) {
        // this is an invite registration
        let payload = this.userForm.getRawValue() as IRegistrationInviteDto;
        console.log("Registration Payload", payload);
        this.apiCallInProgress = true;
        this.authService.RegisterInvitedUser(payload, this.token, this.tokenDecoded).subscribe({
          next: (res: any) => {
            console.log("Invite registration response", res);
            this.apiCallInProgress = false;
          },
          error: (err: any) => {
            console.error("Error during invite registration", err);
            this.apiCallInProgress = false;
          }
        });
      }
      else {
        // this is a full registration
        let payload = this.userForm.getRawValue() as IRegisterAppUser;
        console.log("Registration Payload", payload);
        this.apiCallInProgress = true;
        this.authService.RegisterUser(payload).subscribe({
          next: (res: any) => {
            console.log("Invite registration response", res);
            this.apiCallInProgress = false;
          },
          error: (err: any) => {
            console.error("Error during invite registration", err);
            this.apiCallInProgress = false;
          },
        });;
      }
    }
    catch(err) {
      console.error("Error during registration", err);
      this.toastrService.error('Registration failed. Please try again later.', 'Error');
      // this.util.loader(false);
      return;
    }
   
  }

  public goToReg() {
    // this.userProfile = type;
    
    this.stage = 2;
  }


}
